import image1 from '@/assets/images/news/detail/20200828/1.jpg';
import image2 from '@/assets/images/news/detail/20200828/2.jpg';
import image3 from '@/assets/images/news/detail/20200828/3.jpg';

export default {
  id: '20200828', //  模块 id
  title: '叮咚买菜：数字化、人工智能赋能 卖菜也能高科技', // 标题
  origin: '2020-08-28 11:24  来源：人民网-上海频道', // 新闻来源
  editor: '编辑：董志雯', // 编辑者
  content: [
    {
      type: 0,
      text:
        '不管是刮风下雨，或是烈日炎炎，手机下单后的29分钟里，叮咚买菜的小哥就会把生鲜产品送到你的家门口。最近几个月，城市居民的买菜方式发生了“颠覆性”变化，从线下的菜场买菜，到在手机上动动手指，以生鲜电商为代表的在线消费等新兴产业正展现出强大成长潜力，上海本土互联网企业“叮咚买菜”便是其中一员。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜2017年5月正式上线，2019年，总营收为50亿元(人民币)，随着疫情的暴发，仅2020年2月的单月营收就超过了12亿元。',
      isIndent: false,
    },
    {
      type: 0,
      text: '创业需要定力，专注前置仓卖菜',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '“在过去3年时间里，我们是唯一一家只做‘前置仓卖菜’一件事的生鲜电商公司。认定一件事，专注做好它，这种定力对创业者来说至关重要。” 叮咚买菜创始人梁昌霖说。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '何为“前置仓模式”？ 梁昌霖解释到，“前置仓模式”就是在离消费者最近的地方建立仓库，辐射周边1公里至3公里区域。当然，后台要设立总仓。平台会根据消费者需求预测数据，提前将新鲜菜品由总仓配送至前置仓，待用户下单后立刻送货上门。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '梁昌霖认为，线下门店是“对数模型”，前置仓是“指数模型”，二者有本质区别。“线下门店经营逻辑简单，开店难度小、起步快，不过天花板也相对较低。一家300平方米的生鲜店一天收入1万元就算不错了，算下来1年只有300多万元。一个同样300平方米的前置仓，营收远高于同等面积的线下生鲜店。按一天2000单、每单客单价60元计算，1年营收约为4300万元。”',
      isIndent: false,
    },
    {
      type: 0,
      text: '不断调整菜品，“云菜场”买菜好吃不贵',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜副总裁张奕介绍，目前，叮咚买菜有1700个商品品类，围绕着一个家庭的一日三餐所需而设置，水果蔬菜、肉禽蛋、米面粮油、调料品、水产活鲜、豆制品、奶制品等一应俱全，就像一个手机上的菜市场。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '张奕表示，买菜还需要品类齐全，比如上海人做腌笃鲜需要咸肉、春笋、猪肉、小葱等，如果用户购买时缺少其中一样，就可能就放弃下单了。所以，生鲜电商平台需要齐全的品类。“长三角地区的市民很爱吃活鱼活虾，叮咚买菜是国内首家出售活鱼活虾的生鲜电商平台，并发明了自带输氧和温度调节装置的水产配送箱，保障鱼虾到用户家中时都只只鲜活。”张奕表示。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '此外，叮咚买菜针对市民、企业不同的用户需求调整了产品的结构。宅家期间，市民们对快手菜、半成品类菜品的需求很高。据叮咚买菜的数据显示，近期半成品菜、快手菜的销量增长最快，几乎每天可以售出十几万份半成品菜。在叮咚买菜app上，“快手菜”的品类已经被放到第一栏，以方便消费者选购。另外，速食品销售量也非常高，仅次于蔬菜的销量。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '张奕介绍，“我们今年还开辟了一个栏目叫做‘过年菜’，与小南国、煌上煌、避风塘、新雅等几十家餐饮企业进行合作，将其特色菜做成半成品菜、预制菜，让市民们在家里也能简单加工做出酒店的菜，这些半成品菜的销售量也非常好。”针对市民需求量高的蔬菜、水果等品类，则专门新增了“大份简装”的形式。',
      isIndent: false,
    },
    {
      type: 0,
      text: '全流程的数字化，卖菜也能高科技',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '此外，针对生鲜产品损耗大的痛点，叮咚买菜则根据用户需求积累下大数据，帮助其逐步实现大数据预测，有针对性地根据仓储情况对用户做有效推荐，不仅能有效降低损耗，也能保证到达用户手中的生鲜产品在最佳食用期中。 “数字化很好地解决了这个问题，我们会根据用户习惯做前置仓的贮备、以及各种类型的推荐，对用户和我们来说是双赢。”',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '在配送方面，张奕表示，叮咚买菜目前已实现全流程的数字化，通过科学的算法对配送小哥进行自动调度以及骑行路径的合理规划，保证配送效率的最大化。快，是生鲜配送行业的生命。下班前下单，到家后就能收到货，这已经成为很多用户的生活习惯。在“叮咚买菜”，从用户下单到骑手出发配送，整个操作在3分钟内完成。而从下单到菜品送到用户手里，也仅需要30分钟左右。“叮咚买菜”已经在上海全市建成250多个前置仓，中心城区配送半径为3公里，郊区为5公里。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在杨浦新江湾的前置服务站，记者看到，每个叮咚买菜小哥的位置、订单数量、运行路径都是实时监控状态，不断优化的算法推荐大大提高了配送小哥的送菜效率。在数字化配送支持下，叮咚买菜小哥1个小时可以配送7单，解决7个家庭的吃饭问题，等于用1个小时代替了社会的7个小时运力。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '如何在订单量增加的情况下保证菜品品质？记者看到，运送到前置仓的每一份菜品上都有一个二维码，消费者扫描后即可看到上架日期、批次号、供应商等信息。记者扫描一盒鸡蛋包装上的二维码，手机上立即出现了商品溯源信息：供应商为光明食品集团，上架日期为4月18日，还附有一张资质证书的扫描件。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '记者在水产区看到，有些水产配送箱自带输氧装置，这是企业为了满足客户需求进行的“土发明”。“客户下单买水产，有的要求把鱼杀好洗净，有的要求是活鱼活虾。有什么需求，我们就上什么装备。”配送小哥告诉记者。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '如今，上海正在打造“生鲜电商之都”。上海市商务委副主任刘敏表示，上海支持鼓励生鲜电商、社区电商等新模式健康快速发展，加快“互联网+生活性服务业”创新试验区建设，推动形成生活服务行业电商生态圈，满足多层次多样化消费需求。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在移动互联、物联网、智能算法、自动化等技术赋能下，卖菜这件事的技术门槛提高了，市民的高品质生活也得到了保障。“坚持用户思维来解决大家的生鲜需求问题。”叮咚买菜表示，未来将在数字化、人工智能等技术上再下功夫，力争在需求预测、配送路线规划等方面有持续突破，“卖菜也可以是一个高科技的行业”。（采访对象供图）',
      isIndent: false,
    },
  ],
};
